import { Renewal } from "@/api/williams/renewals";

const messages = {
  ADV1: "API 1104 acceptance criteria is required for CFR 192 and 195 renewals",
  ADV2: "API 1104 App. A OR API 1104 Sec. 9 acceptance criteria is required for CFR",
};

export function getRenewalAdvisories(renewal: Renewal) {
  const advisories: string[] = [];

  if (renewal.acceptanceCriteria) {
    if (!renewal.acceptanceCriteria.includes("1104")) {
      advisories.push(messages.ADV1);
    }
    if (renewal.acceptanceCriteria !== "API 1104 App. A" && renewal.acceptanceCriteria !== "API 1104 Sec. 9") {
      advisories.push(messages.ADV2);
    }
  }

  return advisories;
}
